import { AxiosError } from "axios";
import { UseQueryOptions, useQuery } from "react-query";
import { IInteractionMetricsAvailable, Route } from "@edgetier/watchtower-types";
import { axios } from "utilities/axios";
import { IInteractionMetricsAvailableGetQueryParameters } from "@edgetier/watchtower-types/src/routes/interactions";

/**
 * Request all interaction metrics available
 * @param url       Route URL
 */
const getInteractionMetricsAvailable = async (
    url: string,
    parameters: IInteractionMetricsAvailableGetQueryParameters
) => {
    const { data } = await axios.get<IInteractionMetricsAvailable>(url, {
        params: { ...parameters },
    });
    return data;
};

/**
 * Get all interaction metrics available
 * @returns React Query result.
 */
export const useInteractionMetricsAvailable = <T = IInteractionMetricsAvailable>(
    parameters: IInteractionMetricsAvailableGetQueryParameters = {},
    options: Omit<UseQueryOptions<IInteractionMetricsAvailable, AxiosError, T>, "queryKey" | "queryFn"> = {}
) => {
    const url = Route.InteractionMetricsAvailable;

    return useQuery<IInteractionMetricsAvailable, AxiosError, T>(
        [url, parameters],
        () => getInteractionMetricsAvailable(url, parameters),
        {
            staleTime: 1000 * 60 * 60 * 24,
            ...options,
        }
    );
};
